module.exports = __webpack_public_path__ + "img/wac_vital-signs.b0db85f1.png";